import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/animal-debt/client-comma.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function Clientanimialslider() {
  return (
    <section className="client-animial-slider p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>
              <span style={{ color: "#00806F" }}>Client </span>
              Testimonial
            </h2>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
                1366: {
                  slidesPerView: 1,
                },
                1600: {
                  slidesPerView: 1,
                },
              }}
              className="client-test"
            >
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#00806F"
                        d="m6.53 29.693 2.386-10.665-8.002-7.173 10.57-.949L15.597.85l4.11 10.057 10.571.949-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.693l2.386-10.665-8.002-7.173 10.571-.949L83.451.85l4.11 10.057 10.572.949-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.693l2.385-10.665-8.001-7.173 10.57-.949L49.524.85l4.111 10.057 10.57.949-8 7.173 2.385 10.665-9.066-5.655zM108.313 29.693l2.386-10.665-8.001-7.173 10.57-.949L117.379.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655zM142.242 29.693l2.386-10.665-8.002-7.173 10.571-.949L151.308.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    I wanted to make a game that defied convention, something
                    stupidly fun and ridiculously engaging. TekRevol understood
                    the vision and brought it to life in ways I couldn’t have
                    imagined. The game is getting love from gamers, influencers,
                    and everyone in between!
                  </p>
                  <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#00806F"
                        d="m6.53 29.693 2.386-10.665-8.002-7.173 10.57-.949L15.597.85l4.11 10.057 10.571.949-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.693l2.386-10.665-8.002-7.173 10.571-.949L83.451.85l4.11 10.057 10.572.949-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.693l2.385-10.665-8.001-7.173 10.57-.949L49.524.85l4.111 10.057 10.57.949-8 7.173 2.385 10.665-9.066-5.655zM108.313 29.693l2.386-10.665-8.001-7.173 10.57-.949L117.379.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655zM142.242 29.693l2.386-10.665-8.002-7.173 10.571-.949L151.308.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    I wanted to make a game that defied convention, something
                    stupidly fun and ridiculously engaging. TekRevol understood
                    the vision and brought it to life in ways I couldn’t have
                    imagined. The game is getting love from gamers, influencers,
                    and everyone in between!
                  </p>
                  <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#00806F"
                        d="m6.53 29.693 2.386-10.665-8.002-7.173 10.57-.949L15.597.85l4.11 10.057 10.571.949-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.693l2.386-10.665-8.002-7.173 10.571-.949L83.451.85l4.11 10.057 10.572.949-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.693l2.385-10.665-8.001-7.173 10.57-.949L49.524.85l4.111 10.057 10.57.949-8 7.173 2.385 10.665-9.066-5.655zM108.313 29.693l2.386-10.665-8.001-7.173 10.57-.949L117.379.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655zM142.242 29.693l2.386-10.665-8.002-7.173 10.571-.949L151.308.85l4.111 10.057 10.571.949-8.002 7.173 2.386 10.665-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    I wanted to make a game that defied convention, something
                    stupidly fun and ridiculously engaging. TekRevol understood
                    the vision and brought it to life in ways I couldn’t have
                    imagined. The game is getting love from gamers, influencers,
                    and everyone in between!
                  </p>
                  <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientanimialslider;
